export const QUERY_SOURCE_PREFIX = 'logzioAccountId-';
export const LOGZIO_HIGHLIGHT_TAG = '__logzio-highlight__';
/**
 * Cap the search gateway enforces on every aggregation size it finds, `shard_size` included — its
 * rejection message names `aggregations.size`, but a request with `size: 1000` and the OpenSearch
 * default `shard_size: 1510` is refused while the same `size` with `shard_size: 1000` succeeds.
 */
export const MAX_AGG_SIZE = 1000;
//# sourceMappingURL=constants.js.map